@if (event()) {
  <div
    class="flex p-3 gap-2 min-h-[40px] cursor-pointer w-full"
    (click)="toggleExpand()"
    [class]="expanded ? 'max-h-full' : 'max-h-[200px]'"
  >
    @let interactionType = event().interactionType ?? undefined;
    @if (interactionType) {
      <div>
        <span
          class="fa-icons icon-14 text-neutral-70"
          [class]="interactionType | interactionIcon"
        ></span>
      </div>
    }

    <div class="flex flex-col text-caption grow max-w-[calc(100%-2rem)]">
      <div class="flex justify-between">
        <span class="font-bold line-clamp-2">{{
          'outlook.timeline.eventFor'
            | translate
              : {
                  type: event() | timelineEvent,
                  entry: event().entriesDisplay,
                  for: event() | timelineConnection,
                }
        }}</span>
        @if (event().type.includes('note') && event().important) {
          <span
            class="fa-icons icon-solid icon-14 icon-exclamation pl-1 text-neutral-90"
          ></span>
        }
      </div>
      @if (event().type.includes('note')) {
        <div class="flex flex-col gap-0.5 py-1">
          <span class="text-neutral-90 text-xs">
            {{ 'outlook.timeline.createdBy' | translate }}:
          </span>
          <div class="flex items-center gap-2">
            <span class="avatar avatar-xxs bg-inserv-10">
              {{ event().creator.display | nameInitials }}
            </span>
            <span class="text-neutral-70 text-xs truncate">
              {{ event().creator.display }}
            </span>
          </div>
        </div>
      }

      @if (event().subject) {
        <div class="flex flex-col text-neutral-70">
          <span
            class="smart-word-break"
            [class]="{ 'line-clamp-3': !expanded }"
          >
            {{ event().subject }}
          </span>
          @if (isLongText()) {
            <span
              class="text-link underline cursor-pointer mt-1 text-xs"
              (click)="toggleExpand(); $event.stopPropagation()"
            >
              {{
                expanded
                  ? ('outlook.buttons.showLess' | translate)
                  : ('outlook.buttons.showMore' | translate)
              }}
            </span>
          }
        </div>
      } @else {
        <div class="flex flex-col text-neutral-70">
          <span
            class="smart-word-break"
            [class]="{ 'line-clamp-3': !expanded }"
          >
            {{ event().description }}
          </span>
          @if (isLongText()) {
            <span
              class="text-link underline cursor-pointer mt-1 text-xs"
              (click)="toggleExpand(); $event.stopPropagation()"
            >
              {{
                expanded
                  ? ('outlook.buttons.showLess' | translate)
                  : ('outlook.buttons.showMore' | translate)
              }}
            </span>
          }
        </div>
      }

      <div class="flex mt-2 justify-end">
        <span class="caption text-neutral-70">{{
          event().date.value | date: outlookStore.fullDateTimeFormat()
        }}</span>
      </div>
    </div>
  </div>
}
